import {
    GET_NOTIFICATION_LOGS
} from "../actions/types";

export default (state = {}, action) => {
    let status = 400;
    let data = {}
    let notificationType = 'info'
    if (action.payload != undefined && typeof action.payload.status != 'undefined') {
        status = action.payload.status;
        notificationType = 'success'
        if (status >= 400) {
            notificationType = 'error'
        }
        data = action.payload.data;
    }

    let response = { notificationType: notificationType, type: action.type, status: status, action: 'LIST' };
    switch (action.type) {
        case GET_NOTIFICATION_LOGS:
            response['data'] = data.logs;
            response['action'] = GET_NOTIFICATION_LOGS
            break;
        default:
            return state;
    }
    return response
};
